import Serializable from './serializable';

export class Resource extends Serializable {

	constructor(collectionPath) {
		super();
		this.collectionPath = collectionPath;
	}

	id: string;
	gameId: string;
	collectionPath: string;

	orderNum: number;
	name: string;
	labels: {} = {};
	description: {} = {};
	journalDesc: {} = {};

	availableQuantity: number;
	usedQuantity: number;

	iconUrl: string;

	pictureUrl: string;
	filePath: string;
	pictureLastUpdate: number;
	picture: {} = {};
}
